/** Mirrors server `PROJECT_SLUG_RE` (single-letter id allowed). */
export const PROJECT_SLUG_RE = /^[a-z]$|^[a-z][a-z0-9-]*[a-z0-9]$/;

/** Suggest a project id slug from a display name (e.g. "GenAI Videogame Pipeline" → "genai-videogame-pipeline"). */
export function suggestProjectSlug(displayName: string): string {
  let slug = displayName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  // Must start with a letter.
  slug = slug.replace(/^[^a-z]+/, '');
  if (slug.length > 1 && slug.endsWith('-')) {
    slug = slug.replace(/-+$/, '');
  }
  return slug;
}
